module.exports = __webpack_public_path__ + "media/images/handshake@2x-e956c9a54e319e86905a8f785f144328.png";